import copy from 'copy-to-clipboard'
import React from 'react'
import { FacebookIcon, FacebookShareButton, TwitterIcon, TwitterShareButton } from 'react-share'

import { Button, Dropdown, DropdownItem } from '../../main/components'

export interface NewContentItem {
  newsUrl?: string
}

export default function Share(props: NewContentItem) {
  const handleCopyToClipboard = React.useCallback(() => {
    copy(props.newsUrl ?? '')
  }, [props.newsUrl])

  if (!props.newsUrl) return null

  return (
    <Dropdown aria-label="Share" trigger={<Button rightContent="share" />}>
      <DropdownItem leftContent="link" onClick={handleCopyToClipboard}>
        Copy Link
      </DropdownItem>

      <DropdownItem
        as={TwitterShareButton}
        url={props.newsUrl}
        resetButtonStyle={false}
        leftContent={
          <TwitterIcon size={24} bgStyle={{ opacity: 0 }} iconFillColor="currentColor" className="shrink-0" />
        }
      >
        Share on Twitter
      </DropdownItem>

      <DropdownItem
        as={FacebookShareButton}
        url={props.newsUrl}
        resetButtonStyle={false}
        leftContent={
          <FacebookIcon size={24} bgStyle={{ opacity: 0 }} iconFillColor="currentColor" className="shrink-0" />
        }
      >
        Share on Facebook
      </DropdownItem>
    </Dropdown>
  )
}
